module.exports = __webpack_public_path__ + "static/media/rentRates3BedroomAllDwellings-02.f157822e.png";